var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTedtalk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 20,
    viewBox: "0 0 67 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_348_2958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.24 7.964H0V5H10.042V7.964H6.802V16.563H3.239L3.24 7.964ZM10.594 5.001H20.339V7.965H14.157V9.408H20.339V12.158H14.157V13.601H20.339V16.565H10.594V5.001ZM24.5 13.605H25.896C28.115 13.605 28.438 11.803 28.438 10.714C28.438 9.99 28.198 7.964 25.62 7.964H24.479V13.605H24.5ZM20.938 5.001H26.787C30.641 5.001 32.001 7.85 32.001 10.761C32.001 14.308 30.121 16.563 26.09 16.563H20.939L20.938 5.001Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.69 6.902V5.1H33.153V6.902H36.91V17H38.916V6.902H42.69ZM49.2027 17H51.1237L51.1067 11.067C51.0897 9.078 49.7807 7.888 47.4517 7.888C45.7347 7.888 44.8167 8.279 43.5587 9.027L44.3577 10.387C45.2587 9.775 46.1597 9.469 47.0267 9.469C48.4547 9.469 49.1857 10.149 49.1857 11.288V11.56H46.4487C44.2727 11.577 43.0317 12.631 43.0317 14.28C43.0317 15.878 44.2557 17.085 46.2107 17.085C47.5197 17.085 48.5567 16.694 49.2027 15.895V17ZM46.6187 15.538C45.5307 15.538 44.8677 15.011 44.8677 14.195C44.8677 13.328 45.4627 12.988 46.7377 12.988H49.1857V13.821C49.0837 14.807 48.0127 15.538 46.6187 15.538ZM55.2707 17V4.386H53.3157V17H55.2707ZM61.3043 12.852L63.9563 17H66.2683L62.6643 11.458L66.0133 7.956H63.7693L59.7743 12.002V4.386H57.8193V17H59.7743V14.467L61.3043 12.852Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_348_2958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 12,
    fill: "white",
    transform: "translate(0 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTedtalk);
export default __webpack_public_path__ + "static/media/tedtalk.38bacb24e6be863940dd709358b061ea.svg";
export { ForwardRef as ReactComponent };